import React from 'react';

import { TrackingPixel } from 'proto/Tracking/Tracking';

import styles from '../Tracking.module.scss';
import { TrackingType } from '../types';

interface TrackingElementProps {
    data: TrackingPixel;
    type: TrackingType;
}

const TrackingElement = ({ data, type }: TrackingElementProps) => (
    <>
        {data.urls.map((url, index) =>
            data.active ? (
                <img
                    key={index}
                    src={url}
                    alt="tracking pixel"
                    width="1"
                    height="1"
                    className={styles.PageTracking}
                />
            ) : (
                <span
                    key={index}
                    {...{
                        [`data-${
                            type === TrackingType.General
                                ? 'generaltrackingurl'
                                : 'traveltracking'
                        }`]: url,
                    }}
                    className={styles.PageTracking}
                />
            )
        )}
    </>
);

export default TrackingElement;
